export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
};

export const getCryptoCurrencySymbol = (symbol: string, alias: string) => {
  if (symbol.toLowerCase() === "cred") return alias; //`${import.meta.env.PASSPORT_BRAND_CRED_ALIAS}`
  return symbol;
};
